//StructuralMember.js



import * as THREE from "three";

//------------------------------------------------------------------------
//------------------------------------------------------------------------
//Creating classes for structural members that are inheriting from Three.js classes 
//	and providing additional informations for the analysises
//------------------------------------------------------------------------
//------------------------------------------------------------------------


//Slab class
//------------------------------------------------------------------------
class Slab extends THREE.Shape {

	constructor( points, material, type, level, load){
		super(points)
		this.points = points;
		this.material = material;
		this.type = type;                   			//Plate oder beam structure
		this.level = level;
		this.load = load;                   			//kN/m2
		this.surfaceArea;                   			//m2
		this.crossSection;                        			//m
		this.carbon;                        			// per m2
		this.cost;                          			// per m2
		this.weight;                       				// per m2
	}
}


//Beam class
//------------------------------------------------------------------------
class Beam  extends THREE.Line3{
	
	constructor( start, end, material, type, level, load){
		super(start, end)
		this.start = start;
		this.end = end;
		this.length = start.distanceTo(end);
		this.material = material;                       
		this.type = type;
		this.level = level;
		this.load = load;
		this.crossSection;
		this.carbon;                        			// per member
		this.cost;                          			// per member
		this.weight;                        			// per member
	}
}


// this.loadedLength = this.load * this.length;

//Column class
//------------------------------------------------------------------------
class Column extends THREE.Line3 {

	constructor( start, end, material, level, load){
		super(start, end)
		this.start = start;
		this.end = end;
		this.length = start.distanceTo(end);
		this.material = material;
		this.level = level;
		this.load = load;
		this.shape;
		this.crossSection;
		this.carbon;                        			// per member
		this.cost;                          			// per member
		this.weight;                        			// per member
	}
}


//Building core class
//------------------------------------------------------------------------
class Core  {

	constructor( coreLines, buildingHeight ){
		this.coreLines = coreLines;
		this.buildingHeight = buildingHeight;
		this.circumference;
		this.crossSection;
		this.carbon;                        			// per core
		this.cost;                          			// per core
		this.weight; 									// per core
	}

}


//Foundation class
//------------------------------------------------------------------------
class GroundSlab extends THREE.Shape {

	constructor( points){
		super(points)
		this.points = points;
		this.surfaceArea;                   			//m2
		this.crossSection;                        		//m
		this.carbon;                        			// per m2
		this.cost;                          			// per m2
		this.weight;                       				// per m2
	}
}


//Methods
//------------------------------------------------------------------------
function beamCrossSectionToString(beam, structSystem) {
	var crossSection;

	if(beam.material == "Steel") {
		crossSection = "IPE " + (beam.crossSection.profilHeight * 1000).toString();
	}
	else if(beam.material == "Concrete") {
		crossSection = ((beam.crossSection.beamHeight).toFixed(2)).toString() + " / " + ((beam.crossSection.area / beam.crossSection.beamHeight).toFixed(2)).toString();
	}
	else if(beam.material == "Timber") {

		if(structSystem == "Beam") {
			if(beam.crossSection.beamHeight == 0) {
				crossSection = "Rib";
			}
			else if(beam.crossSection.beamHeight > 0) {
				crossSection = ((beam.crossSection.beamHeight).toFixed(2)).toString() + " / " + ((beam.crossSection.area / beam.crossSection.beamHeight).toFixed(2)).toString();
			}
		}
		else {
			crossSection = ((beam.crossSection.beamHeight).toFixed(2)).toString() + " / " + ((beam.crossSection.area / beam.crossSection.beamHeight).toFixed(2)).toString();
		}
	}
	else if(beam.material == "Hybrid") {
		if(structSystem == "Plate") {
			crossSection = ((beam.crossSection.beamHeight).toFixed(2)).toString() + " / " + ((beam.crossSection.area / beam.crossSection.beamHeight).toFixed(2)).toString();
		}
		else if(structSystem == "Beam") {
			crossSection = "IPE " + (beam.crossSection.profilHeight * 1000).toString();
		}
	}

	return crossSection;
}



function columnCrossSectionToString(column, structSystem) {
	var crossSection;

	if(column.material == "Steel") {
		crossSection = "HEB " + (column.crossSection.profilHeight * 1000).toString();
	}
	else if(column.material == "Concrete") {
		crossSection = ((column.crossSection.columnSideLength).toFixed(2)).toString() + " / " + ((column.crossSection.area / column.crossSection.columnSideLength).toFixed(2)).toString();
	}
	else if(column.material == "Timber") {
		crossSection = ((column.crossSection.columnSideLength).toFixed(2)).toString() + " / " + ((column.crossSection.area / column.crossSection.columnSideLength).toFixed(2)).toString();
	}
	else if(column.material == "Hybrid") {
		if(structSystem == "Plate") {
			crossSection = ((column.crossSection.columnSideLength).toFixed(2)).toString() + " / " + ((column.crossSection.area / column.crossSection.columnSideLength).toFixed(2)).toString();
		}
		else if(structSystem == "Beam") {
			crossSection = "HEB " + (column.crossSection.profilHeight * 1000).toString();
		}
	}

	return crossSection;
}





//------------------------------------------------------------------------
//Export
//------------------------------------------------------------------------


export { Beam, Slab, Column, Core, GroundSlab, beamCrossSectionToString, columnCrossSectionToString }